// Wizard App
import * as Vue from 'vue';
import VideoGrid from './containers/video-grid.vue';

const app = Vue.createApp(VideoGrid);
app.mount('#video-grid-app');